import { flow } from "./flow";

const {
  formField: { flowName, description, variables, integration, logo },
} = flow;

const initialValues = {
  [flowName.name]: "",
  [description.name]: "",
  [integration.name]: [],
  [variables.name]: "",
  [logo.name]: "",
};

export default initialValues;
